import React from 'react';
interface ResourceUtilizationProps {
  label: string;
  percentage: number;
  color?: string;
}
export const ResourceUtilization: React.FC<ResourceUtilizationProps> = ({
  label,
  percentage,
  color = 'bg-green-500'
}) => {
  return <div className="mb-6" data-id="element-87">
      <div className="flex justify-between items-center mb-2" data-id="element-88">
        <span className="text-sm font-medium text-gray-700" data-id="element-89">{label}</span>
        <span className="text-sm font-medium text-gray-700" data-id="element-90">{percentage}%</span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-91">
        <div className={`${color} h-2.5 rounded-full`} style={{
        width: `${percentage}%`
      }} data-id="element-92"></div>
      </div>
    </div>;
};